export interface TeamMember {
  name: string;
  role?: string;
  bio?: string;
  bioKey?: string; // i18n key, e.g., team.bios.vanesa
  initials: string;
  linkedin?: string;
  instagram?: string;
  facebook?: string;
  image?: string; // local path under /public
}

export const team: TeamMember[] = [
  {
    name: "Dr. Rakefet Gonen-Levin",
    role: "Child Safety",
    bioKey: "team.bios.rakefet",
    initials: "RG",
    linkedin: "https://www.linkedin.com/in/rakefet-levin-gonen-257829135",
    instagram: "https://www.instagram.com/dr.rakefet",
    facebook: "https://www.facebook.com/share/1CTHhobk56/",
    image: "/team/rakefet.png",
  },
  {
    name: "Vanesa Telias",
    role: "Product & Strategy Leadership",
    bioKey: "team.bios.vanesa",
    initials: "VT",
    linkedin: "https://www.linkedin.com/in/vanesa-telias-6b03337a",
    image: "/team/vanesa.png",
  },
  {
    name: "Mathias Caldas",
    role: "AI & Engineering",
    bioKey: "team.bios.mathias",
    initials: "MC",
    linkedin: "https://www.linkedin.com/in/mathiascaldas",
    image: "/team/mathias.png",
  },
  {
    name: "Nadav Mansdorf",
    role: "Social Entrepreneur",
    bioKey: "team.bios.nadav",
    initials: "NM",
    linkedin: "https://www.linkedin.com/in/nadav-mansdorf-0918b21b",
    instagram: "https://www.instagram.com/nadavmansdorf",
    facebook: "https://www.facebook.com/share/1Z9qaRSAk5/",
    image: "/team/nadav.png",
  },
];
